const googleMapsClient = require('google-maps');

class GoogleApiHander {
  constructor() {
    googleMapsClient.CLIENT = 'gme-openagentcomau';
    googleMapsClient.VERSION = 'weekly'; // see https://developers.google.com/maps/documentation/javascript/versions
    googleMapsClient.REGION = 'AU'; // see https://developers.google.com/maps/documentation/javascript/localization
    this.googleMapsClient = null;
    this.geocoder = null;
    this.getGeocoder();
  }

  getClient() {
    return this.googleMapsClient;
  }

  initClient() {
    return new Promise((resolve) => {
      if (this.googleMapsClient != null) {
        resolve(this.googleMapsClient);
      } else {
        googleMapsClient.load((google) => {
          this.googleMapsClient = google;
          resolve(this.googleMapsClient);
        });
      }
    });
  }

  getGeocoder() {
    return new Promise((resolve) => {
      if (this.geocoder != null) {
        resolve(this.geocoder);
      } else {
        this.initClient()
          .then((client) => {
            this.geocoder = new client.maps.Geocoder();
            resolve(this.geocoder);
          });
      }
    });
  }

  parseGeocode = (geocode) => {
    const r = geocode.formatted_address;
    const pos = geocode.geometry.location;
    try {
      return {
        latitude: pos.lat,
        longitude: pos.lng,
        streetaddress: r.split(',')[0],
        suburb: r.split(',')[1].match(/[A-Z][^A-Z0-9\s]+\s?/g).join('').replace(/\s+$/, ''),
        state: r.split(',')[1].match(/\b[A-Z]+\b/)[0],
        postcode: r.split(',')[1].match(/\d{4}/)[0],
        geolocationtype: geocode.geometry.location_type,
      };
    } catch (err) {
      console.error(`Error while parsing address ${r}`);
      return null;
    }
  }

  // remove results that aren't an Australian address
  filterGeocode = (results, filterForRealAddresses) => results.filter((x) => {
    let isAddress = true;
    if (filterForRealAddresses) {
      isAddress = x.address_components
        .filter(y => y.types.indexOf('street_number') !== -1)
        .length > 0;
    }
    const isAus = x.formatted_address.indexOf('Australia') > -1;
    return isAus && isAddress;
  });
}

const googleApiHander = new GoogleApiHander();
export default googleApiHander;
